import React from 'react';
import { oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  size: oneOf(['large']),
};

const CLASS_ROOT = 'dialog';

const Dialog = ({ className, children, size, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}-${size}`]: size,
    },
    className
  );

  return (
    <div role="dialog" {...other}>
      <div className={classes} role="document">
        {children}
      </div>
    </div>
  );
};

Dialog.displayName = 'Dialog';
Dialog.propTypes = propTypes;

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js